export default __webpack_public_path__ + "static/media/honeymoon8.3d531a82.webp";